package com.fireavert.react.pages.dashboard

import com.fireavert.events.shared.data_models.models.EventLinkedAction
import com.fireavert.react.active_events.truncateText
import com.fireavert.react.pages.dashboard.styles.DashboardStylesV2
import com.fireavert.react.pages.help.HelpDialog
import com.fireavert.react.shared.styles.HelpStyles
import emotion.css.ClassName
import emotion.css.cx
import kotlinx.datetime.*
import kotlinx.datetime.format.char
import mui.material.IconButton
import mui.material.Tooltip
import mui.material.TooltipPlacement
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.useState
import web.cssom.Color


data class ActionCardTableData(
    val date: String,
    val time: String,
    val property: String,
    val unit: String
) {
    companion object {
        fun fromEventLinkedAction(action: EventLinkedAction, timeZone: TimeZone): ActionCardTableData {
            val dateTime = Instant.fromEpochSeconds(action.created).toLocalDateTime(timeZone)
            return ActionCardTableData(
                date = dateTime.date.format(LocalDate.Companion.Format {
                    monthNumber()
                    char('/')
                    dayOfMonth()
                    char('/')
                    year()
                }),
                time = dateTime.time.format(LocalTime.Companion.Format {
                    this.amPmHour()
                    char(':')
                    minute()
                    amPmMarker("am", "pm")
                }),
                property = action.propertyName,
                unit = action.unitName
            )
        }
    }
}

external interface ActionCardProps : Props {
    var imgSrc: String
    var text: String
    var showLink: Boolean
    var linkText: String
    var linkHref: String
    var number: Int
    var backgroundColor: Color
    var actionCardTableData: List<ActionCardTableData>
    var isMobileVersion: Boolean

}

val ActionCard = FC<ActionCardProps> { props ->
    if (props.isMobileVersion) {
        val (isDialogOpen, setIsDialogOpen) = useState(false)
        div {
            onClick = {
                setIsDialogOpen(true)
            }
            ariaLabel = "ActionCardAndTableContainer"
            className = DashboardStylesV2.actionCardAndTableContainer
            div {
                ariaLabel = "ActionCard"
                className = DashboardStylesV2.actionCard
                div {
                    className = DashboardStylesV2.actionCardTopRow
                    ReactHTML.span {
                        +props.text
                    }
                    img {
                        src = "/static/mobile_arrow.svg"
                    }
                }
                div {
                    className = DashboardStylesV2.actionCardNumber
                    +props.number.toString()
                }
            }
        }
        if (isDialogOpen) {
            ActionCardMobileDialog {
                titleText = props.text
                actionCardTableData = props.actionCardTableData
                number = props.number
                onClose = { setIsDialogOpen(false) }
            }
        }
    } else {
        div {
            ariaLabel = "ActionCardAndTableContainer"
            className = DashboardStylesV2.actionCardAndTableContainer
            div {
                ariaLabel = "ActionCard"
                className = cx(DashboardStylesV2.actionCard, ClassName {
                    backgroundColor = props.backgroundColor
                })
                Tooltip {
                    className = HelpStyles.helpIcon
                    title = HelpDialog.toolTipText(props.text)
                    placement = TooltipPlacement.top
                    IconButton {
                        img {
                            src = "/static/info_icon_black.svg"
                            alt = "Info icon"
                        }
                    }
                }
                div {
                    className = DashboardStylesV2.actionCardTopRow
                    img {
                        src = props.imgSrc
                    }
                    div {
                        +props.text
                    }
                }
                div {
                    className = DashboardStylesV2.actionCardBottomRow
                    if (props.showLink) {
                        a {
                            href = props.linkHref
                            +props.linkText
                        }
                    }
                    div {
                        className = DashboardStylesV2.actionCardNumber
                        +props.number.toString()
                    }
                }
            }
            if (props.actionCardTableData.isNotEmpty()) {
                ActionCardTable {
                    isMobile = false
                    actionCardTableData = props.actionCardTableData
                }
            }
        }
    }
}

external interface ActionCardTableProps : ActionCardProps {
    var isMobile: Boolean
}
val ActionCardTable = FC<ActionCardTableProps> { props ->
    div {
        ariaLabel = "ActionCardTableContainer"
        className = DashboardStylesV2.actionCardTableContainer
        div {
            ariaLabel = "ActionCardTable"
            className = DashboardStylesV2.actionCardTable
            div {
                className = DashboardStylesV2.actionCardTableHeader
                div {
                    className = DashboardStylesV2.actionCardTableRowCell
                    +"Date"
                }
                div {
                    className = DashboardStylesV2.actionCardTableRowCell
                    +"Time"
                }
                div {
                    className = DashboardStylesV2.actionCardTableRowCell
                    +"Property"
                }
                div {
                    className = DashboardStylesV2.actionCardTableRowCell
                    +"Unit #"
                }
            }
            props.actionCardTableData.forEach { data ->
                div {
                    className = DashboardStylesV2.actionCardTableRow
                    div {
                        className = DashboardStylesV2.actionCardTableRowCell
                        if (props.isMobile) {
                            +data.date.substring(0, 5)
                        } else {
                            +data.date
                        }
                    }
                    div {
                        className = DashboardStylesV2.actionCardTableRowCell
                        +data.time
                    }
                    div {
                        className = DashboardStylesV2.actionCardTableRowCell
                        if (props.isMobile) {
                            +truncateText(data.property, 12)
                        } else {
                            +data.property
                        }
                    }
                    div {
                        className = DashboardStylesV2.actionCardTableRowCell
                        +data.unit
                    }
                }
            }
        }
    }
}